import { Component } from '../Component'
import { element } from '../CustomElement'
import { Page, renderFooter, renderSingleRow } from '../flipp-page/Page'
import { i18n } from '../../i18n/I18n'
import { fetchJSON } from '../../utils/fetch'
import { orderBy, uniqBy, startCase } from 'lodash-es'
import { inject } from '../../services/di'
import { ConfigService } from '../../services/ConfigService'
import { LocationService } from '../../services/LocationService'

export interface LinkData {
    name: string
    link: string
}

type FlyersCountryModel = {
    top10Flyers: LinkData[]
    otherFlyers: LinkData[]
}

@element('flipp-flyers-country')
export class FlyersCountry extends Component<any, any> {
    @inject config: ConfigService
    @inject location: LocationService

    async prepare() {
        const country = this.location.locale.split('-').pop()
        const json = await fetchJSON(
            `${this.config.FLIPP_COM_APIS}/city?country=${country}`
        )
        const top10Flyers = [] as LinkData[]
        const otherFlyers = [] as LinkData[]
        const getInCityName = (state: string, city: string) => {
            const cityName = city
                .split(' ')
                .map((c: string) => c.toLowerCase())
                .join('-')
            return `${cityName}-${state.toLowerCase()}`
        }
        const top10Cities =
            this.location.locale === 'en-us'
                ? top10USACities
                : top10CanadianCities
        orderBy(
            uniqBy(json as { cityName: string; state: string }[], 'cityName'),
            (city) => city.cityName.toLowerCase(),
            ['asc']
        ).forEach((cityState) => {
            const prefix =
                this.location.locale === 'en-us' ? 'weekly_ads' : 'flyers'
            const link = `/${getInCityName(cityState.state, cityState.cityName)}/${prefix}`
            const item = { name: startCase(cityState.cityName), link }
            if (top10Cities.indexOf(item.name) >= 0) {
                top10Flyers.push(item)
            } else {
                otherFlyers.push(item)
            }
        })
        return { top10Flyers, otherFlyers } as FlyersCountryModel
    }

    render({ top10Flyers, otherFlyers }: FlyersCountryModel) {
        return (
            <Page show="flyers">
                <div class="marketing link-hub">
                    <div class="content-wrapper">
                        <h1>{i18n('flyersCountry_title')}</h1>
                        <div class="content">
                            <div>{i18n('flyersCountry_content1')}</div>
                            <div>{i18n('flyersCountry_content2')}</div>
                            <div>{i18n('flyersCountry_content3')}</div>
                            <div>
                                {i18n('flyersCountry_content4_a')}
                                <a href={AppleLink}> Apple </a>
                                {i18n('flyersCountry_content4_or')}
                                <a href={AndroidLink}> Android </a>
                                {i18n('flyersCountry_content4_b')}
                            </div>
                        </div>
                        <h2>{i18n('flyersCountry_top10')}</h2>
                        <ul>
                            {top10Flyers.map((flyer) =>
                                renderSingleRow({
                                    link: flyer.link,
                                    text: i18n('flyer_location_title', {
                                        city: flyer.name,
                                    }),
                                    locale: this.location.locale,
                                })
                            )}
                        </ul>
                        <h2>{i18n('flyersCountry_all')}</h2>
                        <div class="content">
                            <div>{i18n('flyersCountry_content5')}</div>
                        </div>
                        <ul class="all-cities">
                            {otherFlyers.map((flyer) =>
                                renderSingleRow({
                                    link: flyer.link,
                                    text: i18n('flyer_location_title', {
                                        city: flyer.name,
                                    }),
                                    locale: this.location.locale,
                                })
                            )}
                        </ul>
                        <div class="content">
                            <div>{i18n('flyersCountry_footnote')}</div>
                        </div>
                    </div>
                    {renderFooter(this.location.locale)}
                </div>
            </Page>
        )
    }
}

const AppleLink = 'https://apps.apple.com/app/flipp-weekly-shopping/id725097967'
const AndroidLink =
    'https://play.google.com/store/apps/details?id=com.wishabi.flipp'

const top10CanadianCities = [
    'Kitchener',
    'Waterloo',
    'Cambridge',
    'Toronto',
    'Ottawa',
    'Montreal',
    'Halifax',
    'Winnipeg',
    'Vancouver',
    'Saskatoon',
]

const top10USACities = [
    'New York',
    'Los Angeles',
    'Chicago',
    'Houston',
    'Phoenix',
    'Philadelphia',
    'San Antonio',
    'San Diego',
    'Dallas',
    'Austin',
]
